export default "__VITE_ASSET__DRvYzNgw__"